var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.529 6.029c.26-.26.682-.26.943 0L8 9.557 11.53 6.03a.667.667 0 1 1 .943.943l-4 4a.667.667 0 0 1-.943 0l-4-4a.667.667 0 0 1 0-.943Z"
  })));
};

export default SvgChevronDown;